import moment from "moment-timezone";
import { getOrderedWeekdays } from "../getOrderedWeekdays";
import { weekdays } from "../../../../../components/Inputs/WeekdaySelect";
import { combineDateAndTime } from "../../../../../utils/helpers/date";

// Helper to get dates for the week OR a single day repeated
export const getTargetDates = (mode: string) => {
    // const userTimezone = moment.tz.guess(true);
    const result: Record<string, string> = {};

    if (mode === "day") {
        // Mode: Day view (Force all weekdays to use the same target date)
        const formattedDate = moment().format("YYYY-MM-DD");
        weekdays.forEach((day) => {
            result[day.toLowerCase()] = formattedDate;
        });
    } else {
        // Mode: Week view (Standard logic)
        const today = moment();
        const orderedWeekdays = getOrderedWeekdays();
        const startOfWeek = today.clone().startOf("week");

        for (let i = 0; i < 7; i++) {
            const dateString = startOfWeek.clone().add(i, "days").format("YYYY-MM-DD");
            const dayName = orderedWeekdays[i].toLowerCase();
            result[dayName] = dateString;
        }
    }

    return result;
};

export const formatTemplateEvents = (events: any, mode: string) => {
    const userTimezone = moment.tz.guess(true);
    // Use the helper to determine if we are mapping to a week or a specific day
    const mappedDates = getTargetDates(mode);

    return events?.map((event: any) => {
        const eventDayKey = event.date.toLowerCase();
        const dateStr = mappedDates[eventDayKey];

        // If for some reason the day isn't found, default to today
        const finalDateStr = dateStr || moment().format("YYYY-MM-DD");

        let start = combineDateAndTime(moment(finalDateStr), moment.parseZone(event?.startDate));
        let end = combineDateAndTime(moment(finalDateStr), moment.parseZone(event?.endDate));

        // Handle overnight shifts
        if (end.isBefore(start)) {
            end.add(1, "day");
        }

        return {
            ...event,
            startDate: moment(start).tz(userTimezone, true),
            endDate: moment(end).tz(userTimezone, true),
            timestamp: moment(start).unix(),
            endTimestamp: moment(end).unix(),
            resourceId: event?.user?.id || event?.user
        };
    });
};